import { defineMessages, IntlShape } from 'react-intl';
import { readM24Error } from '../../../../music24/utils/parseM24LimitError';

const messages = defineMessages({
  teamMember: {
    id: 'app.sml.modals.remove_account.error.teamMember',
    defaultMessage:
      'You joined this workspace as a team member, so you cannot delete the account from here. Ask the workspace owner to remove you in Settings → Team, then delete your account.',
  },
  generic: {
    id: 'app.modals.remove_account.error',
    defaultMessage:
      'There was a problem removing your account. Please try again. If the problem persists, contact support.',
  },
});

/**
 * The sentence the delete-account dialog shows for a failed deletion. The server refuses an
 * old-model team member (`M24_TEAM_OWNER_ONLY`): the owner must remove them first.
 */
export function removeAccountErrorMessage(intl: IntlShape, error: unknown): string {
  if (readM24Error(error)?.code === 'M24_TEAM_OWNER_ONLY') {
    return intl.formatMessage(messages.teamMember);
  }
  return intl.formatMessage(messages.generic);
}
